import React from 'react';
import Icon from '@mdi/react';
import { mdiPartyPopper } from '@mdi/js';

export default function PartyPopperIcon(props){
    return (
        <Icon path={ mdiPartyPopper }
            title="party popper icon"
            size={1}
            color={props.color ? props.color : "black"}/>
    );
};